document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-site-header]');
if (header) {
  let compact = window.scrollY > 40;

  const syncHeader = () => {
    const y = window.scrollY;
    if (!compact && y > 40) {
      compact = true;
      header.classList.add('is-scrolled');
    } else if (compact && y < 8) {
      compact = false;
      header.classList.remove('is-scrolled');
    }
  };

  header.classList.toggle('is-scrolled', compact);
  window.addEventListener('scroll', syncHeader, { passive: true });
}

const revealItems = document.querySelectorAll('[data-reveal]');
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -7% 0px' });

  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}

document.querySelectorAll('.hero [data-reveal]').forEach((item) => {
  requestAnimationFrame(() => item.classList.add('is-visible'));
});

function setFeaturedImage(url) {
  const image = document.querySelector('[data-featured-image]');
  if (!image || !url) return;
  image.src = url;
  image.removeAttribute('srcset');

  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.classList.toggle('is-active', thumb.dataset.image === url);
  });
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const id = form?.querySelector('input[name="id"]');
  const price = document.querySelector('[data-product-price]');
  const sku = document.querySelector('[data-product-sku]');
  const button = form?.querySelector('[data-add-to-cart]');

  if (id) id.value = option.value;
  if (price) price.textContent = option.dataset.price || '';
  if (sku) sku.textContent = option.dataset.sku || '';
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Unavailable';
  }
  setFeaturedImage(option.dataset.image);
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-thumb]');
  if (thumb) setFeaturedImage(thumb.dataset.image);

  const logo = event.target.closest('[data-logo-scroll-top]');
  if (logo) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});
